import { ExpenseType } from "../models/expense-type.model";
import { ExpenseTypeStateModel } from "../state/expense-type.state";

export namespace ExpenseTypeActions {
    export class Refresh {
        static readonly type = '[API-ExpenseType] Refresh'
        constructor() {}
    }
    export class Init {
        static readonly type = '[Storage-ExpenseType] Init'
        constructor(public payload: ExpenseTypeStateModel) {}
    }
    export class Set {
        static readonly type = '[API-ExpenseType] Set'
        constructor(public payload: ExpenseType[]) {}
    }
}
